import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Grid, Group, Paper, Stack, Text } from '@mantine/core';
import { IconMessage2 } from '@tabler/icons-react';

import { useGetProfiles } from '../../api/getProfiles';

import { AddModal } from './AddModal';
import { PagesModal } from './PagesModal';

import { AddButton } from '@/components';
import { Departments } from '@/types';

type Props = {
  department: Departments;
};

export const ProfilesList = ({ department }: Props) => {
  const { data, isLoading } = useGetProfiles({ department });
  const { profiles = [] } = data || {};

  return (
    <>
      <Grid columns={3}>
        {profiles.map((profile) => (
          <Grid.Col key={profile._id} span={1}>
            <Paper shadow="md" radius="md" p="md">
              <Group justify="space-between">
                <Stack gap="xs">
                  <Text size="sm">{profile.name}</Text>
                </Stack>
                <Group gap="xs">
                  <ActionIcon
                    variant="filled"
                    onClick={() => NiceModal.show(PagesModal, { profile, department })}
                    radius="md"
                  >
                    <IconMessage2 />
                  </ActionIcon>
                  {/* <ActionIcon
                    variant="filled"
                    onClick={() => navigate(`/profiles/${profile._id}`)}
                    radius="md"
                    style={{ alignSelf: 'flex-start' }}
                  >
                    <IconSettings />
                  </ActionIcon> */}
                </Group>
              </Group>
            </Paper>
          </Grid.Col>
        ))}
      </Grid>
      <AddButton
        isLoading={isLoading}
        onClick={() => NiceModal.show(AddModal, { department: department! })}
      />
    </>
  );
};
